import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {getRequest} from "../../../../../api";

export const handleGetEquipmentData = createAsyncThunk('step2/handleGetEquipmentData', async() => {
    try{
        const {data} = await getRequest('/motion/equipment');
        return data
    }
    catch(err){
        console.log(err)
    }
})

const step2Slice = createSlice({
    name: 'step2',
    initialState: {
        equipments: [],
        equipmentsData: [],
    },
    reducers: {
        updateEquipments: (state, action) => {
            state.equipments = action.payload
        }
    },
    extraReducers(builder){
        builder
            .addCase(handleGetEquipmentData.fulfilled, (state, action) => {
                state.equipments = action.payload
                state.equipmentsData = action.payload
            })
    }
})

export const {updateEquipments} = step2Slice.actions
export const selectEquipments = state => state.step2.equipments
export const selectEquipmentsData = state => state.step2.equipmentsData

export default step2Slice.reducer